import AppBarChart from "./AppBarChart";
import AppLineChart from "./AppLineChart";
import AppDoughnut from "./AppDoughnut";
export default {
  AppBarChart,
  AppLineChart,
  AppDoughnut,
};
